import { ReactNode, useContext } from "react";

import { BreadcrumbItem } from "./BreadcrumbItem";
import { BreadcrumbContext } from "./BreadcrumbContext";
import { Breadcrumbs } from "./Breadcrumbs";

/** The breadcrumb items. */
export const BreadcrumbItems = (): ReactNode => {
  const { nodes, titleOverride } = useContext(BreadcrumbContext);
  const length = nodes.length;

  if (length === 0) return null;

  return (
    <Breadcrumbs>
      {nodes.map(({ title, path }, index) => {
        const isLast = index === length - 1;
        return <BreadcrumbItem key={path} title={isLast && titleOverride ? titleOverride.title : title} path={isLast ? undefined : path} />;
      })}
    </Breadcrumbs>
  );
};
